<template>
  <div>
    <template
      v-for="(varItem, index) in vars"
    >
      <hr
        v-if="index > 0"
        :key="`h-${varItem.id}`"
      />
      <!-- We have to use setting item here while actor control items requires whole service -->
      <display-control
        :key="`s-${varItem.id}`"
        :component="varItem.component"
        :name="controlName(varItem)"
        :show-label="true"
        :vars="[varItem]"
      />
    </template>
  </div>
</template>

<script>
import DisplayControl from "@/components/services/service/DisplayControl";
import { mapState } from 'vuex';

export default {
  name: 'StructControlList',
  computed: {
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
  },
  methods: {
    controlName(varItem) {
      if (this.currentSnapshot.rev === 2) {
        return varItem.title;
      }
      return varItem.description;
    },
  },
  components: { DisplayControl },
  props: {
    vars: {
      required: true,
      type: Array,
    },
  },
};
</script>

<style scoped>

</style>
